import { render, staticRenderFns } from "./events.vue?vue&type=template&id=871b588c&scoped=true&"
import script from "./events.vue?vue&type=script&lang=ts&"
export * from "./events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871b588c",
  null
  
)

export default component.exports